export default __webpack_public_path__ + "static/media/wallet_image_dashboard.d8bd0d42.png";